import { defineAsyncComponent } from '../compat/vueCompat';
import { requestDialog } from './requestDialog';
import type { UsageRestrictionWarningDialogRequest } from './usageRestrictionWarningDialogRequest';

const UsageRestrictionWarningDialog = defineAsyncComponent(() => import('@mimir/web/pages/item/components/UsageRestrictionWarningDialog.vue'));

export function showUsageRestrictionWarningDialog(req: UsageRestrictionWarningDialogRequest) {
  requestDialog(req, UsageRestrictionWarningDialog);
}
